import { Contact } from "./Contact";
import { Address } from "./Address";

export class Recipient {
    Contact: Contact; 
    Address: Address;  
}